export default __webpack_public_path__ + "static/media/kemira-logo.95716ffa.png";